import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { EmailDialogType } from "src/app/constants/email-dialog-type";
import { TableColumnType } from "src/app/constants/table";
import { EmailDocumentDialogModel } from "src/app/models/dialog";
import { PayStatementEmailCriteria, StatementModel } from "src/app/models/payroll";
import { TableColumn } from "src/app/models/table";
import { HelperService } from "src/app/services/helper.service";
import { PayrollService } from "src/app/services/payroll.service";
import { DialogEmailDocumentComponent } from "../../../shared/dialog/email-document.component";
import { MemberPayStatements, PayStatementListItem, PayStatementModel, PayStatementPayload, PayStatementTable } from "src/app/models/pay-statement";
import { MaskType } from "src/app/constants/masks";
import { FormBuilder, FormGroup } from "@angular/forms";
import { formatDate } from "@angular/common";

@Component({
    selector: 'mwp-pay-stubs',
    templateUrl: './paystubs.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PayrollPayStubsComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollPayStubs;
    public payStatementsMatTableData: MatTableDataSource<PayStatementListItem>;
    public payStatementModel: PayStatementModel;

    public payStatementsColumns: TableColumn[] = [
        {
            columnName: 'Check Date',
            propertyId: 'checkDate',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: 'checkDate',
            isEmit: true,
        },
        {
            columnName: 'Check Number',
            propertyId: 'checkNumber',
            columnType: TableColumnType.label,
            maskType: MaskType.currency,
        },
        {
            columnName: 'Check Amount',
            propertyId: 'checkAmount',
            columnType: TableColumnType.label,
            maskType: MaskType.currency,
        },
        {
            columnName: 'Download',
            propertyId: 'payrollHeaderId',
            columnType: TableColumnType.button,
            dataTypeText: 'Download',
            cssCustomClass: 'mwp-button ignore-min-width',
        },
    ];

    public displayForm: boolean;
    public payStatementForm: FormGroup;
    public hasPSEAdjustmentPeriod: boolean;
    public hasPSDAdjustmentPeriod: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private payrollService: PayrollService,
        private helperService: HelperService,
        private dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        this.payrollService.getPayStatements().subscribe((response: Array<PayStatementListItem>) => {
            this.payStatementsMatTableData = new MatTableDataSource(response);
        });


        const id = sessionStorage.getItem('PY_ID');
        sessionStorage.removeItem('PY_ID');
        if (id != null) {
            const payStatement = new PayStatementListItem();

            payStatement.payrollHeaderId = id;

            this.loadForm(payStatement, true);
        }
    }


    public loadForm(event: PayStatementListItem, isHyperlink: boolean): void {
        const l_PayStatementPayload = new PayStatementPayload();
        if (isHyperlink) {
            l_PayStatementPayload.hyperlinkId = event.payrollHeaderId;
        } else {
            l_PayStatementPayload.payrollHeaderId = event.payrollHeaderId;
        }
        this.payrollService.getPayStatement(l_PayStatementPayload).subscribe((response: PayStatementModel) => {
            this.payStatementModel = response;
            this.displayForm = true;
            this.hasPSEAdjustmentPeriod = this.hasAnyPSEAdjustmentPeriod();
            this.hasPSDAdjustmentPeriod = this.hasAnyPSDAdjustmentPeriod();
        });
    }

    private buildForm(payStatement: PayStatementModel): void {
        this.payStatementForm = this.formBuilder.group({
            payrollHeaderId: [{ value: payStatement.payrollHeaderId, disabled: true }],
        });
    }

    hasAnyPSEAdjustmentPeriod(): boolean {
        return this.payStatementModel.payStatementEarnings.some(pse => !!pse.adjustmentPeriod);
    }

    hasAnyPSDAdjustmentPeriod(): boolean {
        return this.payStatementModel.payStatementDeductions.some(psd => !!psd.adjustmentPeriod);
    }

    public closeForm(): void {
        this.displayForm = false;
        this.payStatementModel = null
    }

    public downloadTableFile(payStatementTable: PayStatementTable): void {
        const l_StatementModel: StatementModel = new StatementModel();
        l_StatementModel.payrollHeaderId = payStatementTable.payrollHeaderId;

        this.executeDownlload(l_StatementModel, payStatementTable.checkDate);
    }

    public downloadFile(payStatementsModel: PayStatementModel): void {
        const l_StatementModel: StatementModel = new StatementModel();
        l_StatementModel.payrollHeaderId = payStatementsModel.payrollHeaderId;

        this.executeDownlload(l_StatementModel, payStatementsModel.payStatementDistribution.checkDate);
    }

    private executeDownlload(payload: StatementModel, checkDate: Date): void {
        this.payrollService.downloadPayStatementReport(payload).subscribe((response: Blob) => {
            let l_BinaryData = [];
            l_BinaryData.push(response);
            this.helperService.downloadDocument(l_BinaryData, response.type, `PayStub_${formatDate(checkDate, 'yyyyMMdd', 'en_US')}.pdf`);
        });
    }

    public emailDocument(payStatementsModel: PayStatementModel) {
        const dialogRef = this.dialog.open(DialogEmailDocumentComponent, {
            data: EmailDialogType.payStub,
            panelClass: 'mwp-modal-override-800'
        });

        dialogRef.afterClosed().subscribe((response: EmailDocumentDialogModel) => {
            if (response != null) {
                const l_PayStatementEmailCriteria = new PayStatementEmailCriteria();
                l_PayStatementEmailCriteria.payStatementId = payStatementsModel.payrollHeaderId;
                l_PayStatementEmailCriteria.toAddress = response.email;
                this.payrollService.sendPayStatementToEmail(l_PayStatementEmailCriteria).subscribe(() => { });
            }
        });
    }
}
